export default __webpack_public_path__ + "static/media/keep_working_activity_course.24adf9bd.svg";